function toUrlSearchParams(data) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(data)) {
        if (value === null) {
            params.append(key, "null");
            continue;
        }
        if (value == null) {
            continue;
        }
        if (!Array.isArray(value)) {
            if (typeof value === "object") {
                const nested = Object.entries(value);
                nested.forEach(([name, value]) => {
                    params.append(name, value);
                });
                continue;
            }
            params.append(key, value.toString());
            continue;
        }
        value.forEach((v) => {
            if (value === null) {
                params.append(key, "null");
                return;
            }
            if (v == null) {
                return;
            }
            params.append(key, v.toString());
        });
    }
    return params;
}
function extractHeaderRel(headers, rel) {
    for (const [k, v] of headers) {
        if (k.toLowerCase() !== "link") {
            continue;
        }
        for (const links of v.split(",").map((s) => s.trim())) {
            const [url, relPar] = links.split(";").map((s) => s.trim());
            if (!url || !relPar) {
                continue;
            }
            const urlMatch = url.match(/^<(.+?)>$/)?.[1];
            const relMatch = relPar.match(/rel="(.+?)"/)?.[1];
            if (relMatch == rel && urlMatch) {
                try {
                    return new URL(decodeURIComponent(urlMatch));
                }
                catch (e) {
                    console.error(e);
                    return undefined;
                }
            }
        }
    }
    return undefined;
}
export class MagApiClient {
    baseUrl;
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    async call({ endpoint, method, paginated }, data, pathParams, token) {
        const authorizationToken = token ?? undefined;
        const authorization = authorizationToken
            ? `Bearer ${authorizationToken}`
            : undefined;
        let endpointTemplated = endpoint;
        for (const name in pathParams) {
            endpointTemplated = endpointTemplated.replace(`:${String(name)}`, `${pathParams[name]}`);
        }
        const baseUrl = this.baseUrl.replace(/\/+$/, "");
        let url = `${baseUrl}${endpointTemplated}`;
        const headers = new Headers();
        if (method === "GET") {
            const query = toUrlSearchParams(data);
            if (query) {
                url += `?${query.toString()}`;
            }
        }
        else {
            headers.append("Content-Type", "application/json");
        }
        if (authorization) {
            headers.append("Authorization", authorization);
        }
        return await fetch(url, {
            method,
            body: method !== "GET" ? JSON.stringify(data) : undefined,
            credentials: "omit",
            cache: "no-cache",
            headers,
        })
            .then(async (res) => {
            const body = res.status === 204 ? null : await res.json();
            if (res.status === 200) {
                if (paginated) {
                    return {
                        prev: extractHeaderRel(res.headers, "prev"),
                        data: body,
                        next: extractHeaderRel(res.headers, "next"),
                    };
                }
                else {
                    return body;
                }
            }
            else if (res.status === 204) {
                if (paginated) {
                    return {
                        prev: extractHeaderRel(res.headers, "prev"),
                        data: [],
                        next: extractHeaderRel(res.headers, "next"),
                    };
                }
                else {
                    return null;
                }
            }
            else {
                throw body;
            }
        })
            .catch((e) => {
            if (typeof e === "object" && e?.["code"]) {
                throw e;
            }
            console.error("Generic API error. This should not usually happen!", e);
            throw {
                status: -1,
                code: "Client:GenericApiError",
                message: e,
            };
        });
    }
}
//# sourceMappingURL=be-api.js.map